module.exports = __webpack_public_path__ + "static/media/forklift_idle.f92ff60d.svg";